<template>
  <b-modal
    id="integration-delete-modal"
    ref="integrationDeleteModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to delete this integration?</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'IntegrationDeleteModal',
  data() {
    return {
      integration: {},
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      integrationDeleted: 'integration/integrationDeleted',
      apiError: 'integration/apiError',
    }),
  },
  watch: {
    integrationDeleted(deleted) {
      if (deleted) {
        this.$emit('deleted', deleted);
        this.integration = {};
        this.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteIntegration: 'integration/deleteIntegration',
    }),
    commitDelete() {
      this.deleting = true;
      this.deleteIntegration({
        merchant_id: this.$route.params.merchant_id,
        integration_id: this.integration.id,
      });
    },
    setIntegration(integration) {
      this.integration = integration;
    },
    show() {
      this.$refs.integrationDeleteModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.integrationDeleteModal.hide();
    },
  },
};
</script>
